var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Below is the dashboard regarding the System Problem Reports (SPRs) in the system.")]),_c('numbers-dash')],1)}
var staticRenderFns = []

export { render, staticRenderFns }